module.exports = __webpack_public_path__ + "static/media/bestPresenter1.62c2ab5a.jpg";